import * as React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useRecordContext, useTranslate } from 'react-admin';

interface ResponseCounts {
    target_count: number;
    responded_count: number;
}

export const getCampaignResponseRate = ({ target_count, responded_count }: ResponseCounts) => {
    if (!Number.isInteger(target_count) || !Number.isInteger(responded_count) ||
        target_count < 0 || responded_count < 0 || responded_count > target_count) {
        throw new Error('Invalid campaign response counts');
    }
    return target_count === 0 ? 0 : responded_count / target_count * 100;
};

export const getCampaignResponseOpacity = (rate: number) => 0.35 + rate / 100 * 0.65;

const CampaignResponseRateField = (_props: { label: string; sortable?: boolean }) => {
    const record = useRecordContext<ResponseCounts>();
    const translate = useTranslate();
    if (!record) return null;
    const rate = getCampaignResponseRate(record);
    const label = translate('resources.campaign.fields.response_rate');
    return (
        <Box sx={{ minWidth: 150 }}>
            <Typography variant="body2" sx={{ whiteSpace: 'nowrap', mb: 0.5 }}>
                {Math.round(rate)} % · {record.responded_count}/{record.target_count}
            </Typography>
            <LinearProgress
                variant="determinate"
                value={rate}
                color="primary"
                aria-label={label}
                aria-valuetext={`${Math.round(rate)} % (${record.responded_count}/${record.target_count})`}
                sx={theme => ({
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: alpha(theme.palette.primary.main, 0.08),
                    '& .MuiLinearProgress-bar': {
                        borderRadius: 4,
                        backgroundColor: alpha(theme.palette.primary.main, getCampaignResponseOpacity(rate)),
                    },
                })}
            />
        </Box>
    );
};

export default CampaignResponseRateField;
